module.exports = __webpack_public_path__ + "static/media/ascenda logo white.0f25b790.webp";